


















































import { Component, Prop, Vue } from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";

import addRoutes from "@root/lib/addRoutes";
import router from "@root/router";
import {
  K1_PCR_apolloClient,
  K1_TBR_apolloClient,
  K1_YGJ_apolloClient
} from "@root/lib/allApolloClient";
import {
  login,
  loginNew,
  loginYgj,
  queryCurrentMemberExt
} from "@root/graphql/Login.gql";

localStorage.clear();

let AUTH_TOKEN;
let isMainProject = process.env.VUE_APP_QIANKUN_APPLICATION_TYPE === "MAIN";

const RootVuex = namespace("root");
@Component({})
export default class NewLogin extends Vue {
  @RootVuex.Action menuListByRole;
  passwordType: boolean = true;
  errorMsg: any = "";
  mixinTimerError: any = null;
  loading: any = false;
  form: any = {
    account: "",
    password: ""
  };

  rules: any = {
    account: [{ required: true, message: "用户名不能为空" }],
    password: [{ required: true, message: "密码不能为空" }]
  };
  menuList: any = [];
  userTypeList: any = [];
  // 获取菜单
  async getMenuList(roleCode) {
    let res = await this.menuListByRole({
      roleCode
    });
    this.menuList = res || [];
  }
  // 获取用户类型（pcr| tbr | 集团用户）
  async getUserTypeList() {
    let res = await this.getUserType();
    this.userTypeList = res || [];
  }

  async handleLogin() {
    let $form: any = this.$refs.loginForm;
    $form.validate(async valid => {
      if (valid) {
        try {
          this.loading = true;
          await Promise.all([
            this.onLogin_frontend(),
            this.onLogin_tbr(),
            this.onLogin_cn()
          ]);
          // 获取菜单
          await Promise.all([this.getUserTypeList()]);
          // await Promise.all([this.getMenuList(), this.getUserTypeList()]);
          // const menuList = await this.menuListByRole();
          // if (!this.menuList || this.menuList.length === 0) {
          //   this.$router.push({ name: "Login" });
          //   this.$message.warning("当前用户无任何菜单，请联系管理员！");
          // } else {
          //   addRoutes(router);
          // }
          // let list = await this.getUserType();
          let list = this.userTypeList;
          let len = list.length;
          if (!list || len === 0) {
            this.$message.warning("当前用户无任何类型权限，请联系管理员！");
          }
          if (len > 1) {
            sessionStorage.setItem("loginTypeList", JSON.stringify(list));
            this.$router.push({
              name: "loginType"
            });
          } else if (len === 1) {
            let {
              memberType,
              marketType,
              memberName,
              memberCode,
              roleCode,
              oaStatus,
              status
            } = list[0];
            await this.getMenuList(roleCode || "");
            if (!this.menuList || this.menuList.length === 0) {
              // this.$router.push({ name: "Login" });
              this.$message.warning("当前用户无任何菜单，请联系管理员！");
              return;
            } else {
              addRoutes(router);
            }
            localStorage.setItem("marketType", marketType);
            localStorage.setItem("memberType", memberType);
            localStorage.setItem("memberName", memberName);
            localStorage.setItem("memberCode", memberCode);
            localStorage.setItem("menuRoleCode", roleCode || "");
            localStorage.setItem("loginTypeList", JSON.stringify(list));
            let isOaCooperation: any =
              (oaStatus || status) === "11" ? "11" : "";
            localStorage.setItem("oaStatus", oaStatus || status);
            localStorage.setItem("isOaCooperation", isOaCooperation);
            // 根据 isOaCooperation 来判断账号的oa合作状态，非合作状态只有搜索和导出的权限

            this.$router.push("/");
          }
        } finally {
          this.loading = false;
        }
      }
    });
  }

  async onLogin_cn() {
    // 这里的逻辑来自于 原先的登录逻辑 这里只是搬运
    try {
      let {
        data: {
          login: { optionalTenants, ...other }
        }
      } = await K1_PCR_apolloClient.query({
        query: loginNew,
        variables: {
          identity: { ...this.form, type: "OP", tenantCode: "100007" }
        }
      });

      const userInfos = { ...other };
      let { userAuthToken } = userInfos;
      localStorage.setItem("userInfo", JSON.stringify(userInfos));
      localStorage.setItem("org", "default");
      localStorage.setItem("account", this.form.account);
      // 新增的逻辑
      localStorage.setItem("AUTH-TOKEN-K-ONE-CN", userAuthToken);
      if (isMainProject) {
        localStorage.setItem("AuthToken", userAuthToken);
      }
    } catch (error) {
      this.showError(error);
      throw new Error(this.errorMsg);
    }
  }

  async onLogin_frontend() {
    try {
      let {
        data: {
          login: { userAuthToken, firstLogin }
        }
      } = await K1_YGJ_apolloClient.query({
        query: loginYgj,
        variables: {
          identity: { ...this.form, type: "OP", tenantCode: "100007" }
        }
      });
      localStorage.setItem("AUTH-TOKEN-K-ONE-FRONTEND", userAuthToken);
      AUTH_TOKEN = userAuthToken;
      localStorage.setItem("firstLogin", firstLogin ? "1" : "0");
      if ((window as any).__GTECH_VARIABLES_APP_CODE__ === "K-ONE") {
        localStorage.setItem("AuthToken", userAuthToken);
      }
    } catch (error) {
      this.showError(error);
      throw new Error(this.errorMsg);
    }
  }

  async onLogin_tbr() {
    try {
      let {
        data: {
          login: { userAuthToken }
        }
      } = await K1_TBR_apolloClient.query({
        query: loginNew,
        variables: {
          identity: { ...this.form, type: "OP", tenantCode: "100007" }
        }
      });
      localStorage.setItem("AUTH-TOKEN-K-ONE-TBR", userAuthToken);
      if ((window as any).__GTECH_VARIABLES_APP_CODE__ === "WIN-TOGETHER-TBR") {
        localStorage.setItem("AuthToken", userAuthToken);
      }
    } catch (error) {
      this.showError(error);
      throw new Error(this.errorMsg);
    }
  }

  async getUserType() {
    try {
      let { data } = await K1_YGJ_apolloClient.query({
        query: queryCurrentMemberExt
      });
      return data ? data.api : [];
    } catch (error) {
      this.showError(error);
      throw new Error(this.errorMsg);
    }
  }

  triggerPassword() {
    this.passwordType = !this.passwordType;
  }
  showError(error) {
    let { graphQLErrors } = error;
    if (graphQLErrors && graphQLErrors[0]) {
      const { message, code } = graphQLErrors[0];
      this.errorMsg = message;
      clearTimeout(this.mixinTimerError);
      this.mixinTimerError = setTimeout(() => {
        this.errorMsg = "";
      }, 3000);
    }
  }
  handleForget() {
    this.$router.push({
      name: "ForgetPassword"
    });
  }
}
